import { useAuth, useI18n } from '../app/context';
import { Icon } from '../components/Icon';
import { Button } from '../components/ui';
import { useCopy } from '../lib/useCopy';
import styles from './auth.module.css';

/**
 * What an account that is not on the allowlist sees.
 *
 * It doubles as the setup screen: the owner signs in here first, copies the
 * user ID off this page and runs `pnpm claim` with it.
 */
export function Locked() {
  const { t } = useI18n();
  const { user, signOut } = useAuth();
  const { copied, copy } = useCopy();

  const uid = user?.uid ?? '';
  const command = `pnpm claim ${uid}`;

  return (
    <div className={styles.screen}>
      <div className={styles.card}>
        <div className={styles.brand}>
          <span className={styles.lockIcon}>
            <Icon name="lock" size={22} />
          </span>
          <h1 className={styles.heading}>{t('auth.locked.title')}</h1>
          <p className={styles.body}>{t('auth.locked.body', { email: user?.email ?? '—' })}</p>
        </div>

        <div className={styles.block}>
          <div className={styles.blockHead}>
            <span className="eyebrow">{t('auth.locked.uidLabel')}</span>
            <Button variant="ghost" onClick={() => void copy(uid)}>
              <Icon name={copied ? 'check' : 'copy'} size={16} />
              {copied ? t('common.copied') : t('common.copy')}
            </Button>
          </div>
          <code className={styles.uid}>{uid}</code>
        </div>

        <div className={styles.block}>
          <span className="eyebrow">{t('auth.locked.ownerTitle')}</span>
          <p className={styles.body}>{t('auth.locked.ownerBody')}</p>
          <code className={styles.command}>
            <span className={styles.commandPrompt}>$ </span>
            {command}
          </code>
        </div>

        <div className={styles.footerRow}>
          <Button variant="ghost" onClick={() => void signOut()}>
            {t('common.signOut')}
          </Button>
        </div>
      </div>
    </div>
  );
}
